import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

const STOCK_MOVEMENT_QUERY =
  "SELECT item_master.item_name AS item_name, inventory_monthly_snapshots.product_id, inventory_monthly_snapshots.purchase_rate, inventory_monthly_snapshots.opening_stock, inventory_monthly_snapshots.closing_stock, (COALESCE(inventory_monthly_snapshots.closing_stock, 0) - COALESCE(inventory_monthly_snapshots.opening_stock, 0)) AS movement_count, inventory_monthly_snapshots.snapshot_month FROM inventory_monthly_snapshots LEFT JOIN item_master ON item_master.id = inventory_monthly_snapshots.product_id WHERE inventory_monthly_snapshots.transaction_branch_id = '<branch_id>'";

export const screen_171_stock_movement: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Stock movement",
        style: {
            backgroundColor: "#F9FAFB", // bg-gray-50
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16,
                },
                childComponents: [
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        titleValue: "item_name",
                        Name: "stock_monthly_snapshots",
                        Form: {
                            Name: "stock_monthly_snapshots",
                            TableName: "inventory_monthly_snapshots",
                            DisplayName: "Stock",
                            Query: STOCK_MOVEMENT_QUERY,
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "Item name",
                                    IsMandatory: true,
                                    BindValue: "code_number",
                                    Json_Attribute: "item_name",
                                    componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                    LookupName: "item_name_lookup",
                                    ControlType: "MultiSelect",
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Snapshot month",
                                    IsMandatory: false,
                                    BindValue: "txt_month",
                                    Json_Attribute: "snapshot_month",
                                    componentType: ComponentType.SELECT_DROPDOWN,
                                    LookupName: "snapshot_months",
                                    IncludeNotSet: true,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Opening stock",
                                    IsMandatory: true,
                                    BindValue: "opening_stock",
                                    Json_Attribute: "opening_stock",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Closing stock",
                                    IsMandatory: true,
                                    BindValue: "closing_stock",
                                    Json_Attribute: "closing_stock",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Movement count",
                                    IsMandatory: false,
                                    BindValue: "movement_count",
                                    Json_Attribute: "movement_count",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
];
